var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"patient-header-menu__item",class:{
    active: _vm.isActive,
  },on:{"click":_vm.fnClick}},[_c('span',{class:{
      'router-link-active': _vm.isActive,
    }},[_vm._v(_vm._s(_vm.menu.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }